<template>
    <PageContainer :isLoading="isLoading" :error="error">
        <KnownActionsList />
    </PageContainer>
</template>

<script>
import KnownActionsList from './KnownActionsList';

import { fetchUser } from '@/mixins';

export default {
    mixins: [fetchUser],

    components: { KnownActionsList },
};
</script>
